import React, { Component } from 'react';
import { Switch, Route, Router } from 'react-router-dom';

import Home from './components/Explore/Home'
import Project from './components/Explore/Project'
import Howitworks from './components/Howitworks/Howitworks'
import Yourprojects from './components/Yourprojects/Yourprojects'
import Create from './components/Create/Create'
import Admin from './components/Admin/Admin'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

import Auth from './Auth/Auth';
import Callback from './Auth/Callback';
import history from './history';

import ActionsFactory from './Actions';
import { EventEmitter2 } from 'eventemitter2';
import StoreFactory from './Store';
import events from './Events';

import 'antd/dist/antd.css';
import './App.css';

const dispatcher = new EventEmitter2();
const Store = StoreFactory(dispatcher, events);
const Actions = ActionsFactory(dispatcher, events);
const auth = new Auth();

const handleAuthentication = ({location}) => {
    let currentStorage = localStorage.getItem('connexionUri');
	if(currentStorage === null){
	    let currentUrl = window.location.href;
	    if(currentUrl !== process.env.REACT_APP_BACKON_APP + '/' && currentUrl.indexOf('#access_token') === -1){
	    	Actions.stockConnexionUri(window.location.href);
	    }
	}
	if (/access_token|id_token|error/.test(location.hash)) {
		auth.handleAuthentication();
	} else {
		auth.login();
	}
}

class Routing extends Component {

	constructor(props) {
	    super(props);
	    this.appState = Store.getState();
	}

	componentWillMount(){
	    dispatcher.on(events.REFRESH, this.setState.bind(this));
	}

	render() {
		return (
			<Router history={history}>
				{ auth.isAuthenticated() ? (
					<div>
						<Header 
						isAdmin={this.appState.isAdmin}
						currentUser={this.appState.currentUser} 
						currentRoute={this.appState.currentRoute}
                		logOut={auth.logout} 
						actions={Actions}
						currentUserProjectsNotSeen={this.appState.currentUserProjectsNotSeen} />
					  	<Switch>
					    	{ this.appState.currentUser.email &&
						        <Route exact path='/' render={(props) => <Home
									currentUserProjectsNotSeen={this.appState.currentUserProjectsNotSeen}
									projects={this.appState.projects} 
									transactions={this.appState.transactions}
									currentUser={this.appState.currentUser}
									emptyProjects={this.appState.emptyProjects}
									connexionUri={this.appState.connexionUri}
									actions={Actions}/>}/>
							}
					    	{ this.appState.currentUser.email &&
								<Route path='/projects/:id' render={(props) => <Project
									{...props} 
									projects={this.appState.projects}
									isModalVisible={this.appState.isModalVisible}
									modalVisible={this.appState.modalVisible}
									currentUser={this.appState.currentUser} 
									usersList={this.appState.usersList} 
									usersListFiltered={this.appState.usersListFiltered}
									backingIsLoading={this.appState.backingIsLoading} 
									inviteBackersIsLoading={this.appState.inviteBackersIsLoading}
									deleteProjectIsLoading={this.appState.deleteProjectIsLoading}
									achieveProjectIsLoading={this.appState.achieveProjectIsLoading}
									deleteRedirect={this.appState.deleteRedirect}
									formRedirect={this.appState.formRedirect}
									refreshProject={this.appState.refreshProject}
									APIOptions={this.appState.APIOptions}
									actions={Actions} />}/>
							}
							<Route path='/howitworks' render={(props) => <Howitworks
								actions={Actions} />}/>
					    	{ this.appState.currentUser.email &&
								<Route path='/yourprojects' render={(props) => <Yourprojects
									projects={this.appState.projects} 
									currentUserProjects={this.appState.currentUserProjects} 
									currentUserBackedProjects={this.appState.currentUserBackedProjects}
									currentUserProjectInvitations={this.appState.currentUserProjectInvitations}
									currentUserProjectsNotSeen={this.appState.currentUserProjectsNotSeen}
									currentUser={this.appState.currentUser}
									emptyPrivateProjects={this.appState.emptyPrivateProjects}
									answerIsLoading={this.appState.answerIsLoading}
									actions={Actions} />}/>
							}
							<Route exact path='/user' component={Yourprojects}/>
							<Route exact path='/create' render={(props) => <Create
								actions={Actions}
								currentUser={this.appState.currentUser}
								APIOptions={this.appState.APIOptions}
								formRedirect={this.appState.formRedirect}/>}/>
					    	{ this.appState.currentUser.email &&
								<Route path='/create/:id' render={(props) => <Create
									{...props} 
									projects={this.appState.projects} 
									currentProject={this.appState.currentProject}
									actions={Actions}
									currentUser={this.appState.currentUser}
									APIOptions={this.appState.APIOptions}
									formRedirect={this.appState.formRedirect}/>}/>
							}
							{ this.appState.isAdmin && <Route path='/admin' render={(props) => <Admin
								allprojects={this.appState.allprojects} 
								actions={Actions}
								transactions={this.appState.transactions}
								wallets={this.appState.wallets}
								currentUser={this.appState.currentUser}/>}/>
							}
					  	</Switch>
					  	<Footer />
				  	</div>
			  	) : (
		          <Route path="/" render={(props) => {
		              handleAuthentication(props);
		              return <Callback {...props} /> 
		            }}/>
		        )}
			</Router>
		)
	}
}


export default Routing



// WEBPACK FOOTER //
// ./src/Routing.js